import React from "react";
import TableHeader from "./TableHeader";
import TableData from "./TableData";
import Title from "../text/Title";
import InputTexto from "../input/InputTexto";
import { GroupedPaymentList, PaymentDetail } from "../../types-interfaces/interfaces";
import { SelectedPayments } from "../../types-interfaces/types";

interface TableProps extends React.HTMLAttributes<HTMLElement>{
  data?: Array<PaymentDetail | GroupedPaymentList> | undefined
  headersName?: Array<string> | undefined
  columnsWidth?: Array<number> | undefined
  title?: string | undefined
  search?: boolean | undefined
  isDetail?: boolean | undefined   
  onCheck?: (item: PaymentDetail | GroupedPaymentList, evt: React.MouseEvent<HTMLInputElement, MouseEvent>, isDetail: boolean | undefined, index: number, paymentCount: number) => void | undefined
  checkAll?: boolean | undefined
  index?: number | undefined
  selectionType?: "single" | "multiple" | undefined
  selectedItem?: any | undefined
  dataSelected: Array<SelectedPayments>
};

interface TableState {
  data?:Array<PaymentDetail | GroupedPaymentList>
  filterText?: string
}

function filterData<T>(data:Array<T> | undefined, filter: string):Array<T>{
  let newArray = new Array<T>();
  data && data.forEach((row) => {
    if (row){
      for(let key of (Object.keys(row) as (keyof typeof row)[])){
        let val = row[key];
        if (val && val.toString().toUpperCase().includes(filter.toUpperCase())){
          newArray.push(row);
          break;
        }
      }
    }
  });

  return newArray;
}

class Table extends React.Component<TableProps,TableState> {

  state: any = {data: this.props.data, filterText:''};

  handleFilterData = (e:React.ChangeEvent<HTMLInputElement>) => {
    let newFilterText = e.currentTarget.value;
    this.setState({
      data: filterData(this.props.data, newFilterText),
      filterText: newFilterText
    });
  } 

  componentDidUpdate(prevProps: TableProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: filterData(this.props.data, this.state.filterText) })
    }
  }

  render() {    
    if (this.props.data && this.props.headersName && this.props.columnsWidth){      
      return (
        <div className={this.props.isDetail? this.props.className + '-row-cell ' + this.props.className + '-colspan' :  this.props.className + '-main'}>
          { (this.props.title || this.props.search) &&
            <div className={this.props.className + '-title'}>
            { this.props.title &&
              <Title text={this.props.title} className={this.props.className + '-title-text'}/>            
            }
            { this.props.search &&
              <InputTexto
                className={this.props.className + '-title-search'}
                onChange={this.handleFilterData}
                value={this.state.filterText}
                searchicon={"true"}
                alt="busqueda"
              />
            }
            
          </div>
          }
          
          <div className={this.props.className}>
            <TableHeader
              className={this.props.className + '-header'}
              headersName={this.props.headersName}
              columnswidth={this.props.columnsWidth}
              isDetail={this.props.isDetail}
            />
            <TableData
              className={this.props.className + '-data'}              
              data={this.state.data}
              isDetail={this.props.isDetail}
              onCheck={this.props.onCheck}
              checkAll={this.props.checkAll}
              selectionType={this.props.selectionType}
              selectedItem={this.props.selectedItem}
              dataSelected={this.props.dataSelected}      
            />
          </div>
        </div>
        
      );
    }
}}

export default Table;